import { fetchData } from './fetchData';
import { RepairDetail } from '../data/Repair';

type RepairDetailRequestData = {
    // 報修單號 *不可模糊查詢
    name: string,
    line_uid: string,
    login: string,
};

function repairDetail(data: RepairDetailRequestData): Promise<RepairDetail> {
    return fetchData('api/repair_detial', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: RepairDetail) => resData);
}

export { repairDetail };
